export default "__VITE_ASSET__Bmln$aLq__"